import { MenuItens } from 'core/domains';

import { sharedConfig } from './shared';

import type { Config } from 'core/domains/config';

const { app, ...shared } = sharedConfig;
const date = new Date();
const year = date.getFullYear();

const configCatKey = process.env.REACT_APP_EUD_CONFIG_CAT_KEY || '';
const newRelicLicenseKey = process.env.REACT_APP_NEW_RELIC_LICENSE_KEY || '';
const recaptchaSecretKey = process.env.REACT_APP_RECAPTCHA_EUD_SECRET_KEY || '';
const oneTrustCookieKey = process.env.REACT_APP_EUD_ONE_TRUST_COOKIE_CONSENT_ID || '';

const configBase = {
  app: {
    name: 'Eudora',
    basename: '',
    short: 'eud',
    slugname: 'eudora',
    staticUrl: 'http://localhost:8002',
    fallbackUrl: 'https://hreseller-checkout-eudora-mf-vd.grupoboticario.com.br',
    logout: '/login',
    ...app,
  },
  bff: {
    applicationID: '862d5019-ce14-440b-9f10-a893c620849b',
    baseUrl: 'https://api.hml.grupoboticario.com.br/local/v1/unified-bff/',
    clientID: 'aimzXUSpTyqyhnB9f9oVdhhrroBP0wQM',
  },
  configCat: {
    sdkKey: configCatKey,
  },
  acceptedCards: ['amex', 'diners', 'elo', 'hipercard', 'mastercard', 'visa'],
  cashbackLabel: 'Eu Posso Mais',
  cashbackToolTip: true,
  communication: {
    userNamingConvention: {
      singular: 'Representante',
      plural: 'Representantes',
    },
    sac: {
      openingHours: {
        week: {
          days: 'Segunda a sexta',
          hours: '8h às 20h',
        },
        weekend: {
          days: 'Sábado',
          hours: '9h às 16h',
        },
      },
      phone: '0800-727-4533',
      whatsapp: '0800-744-0080',
      whatsappText:
        'Olá, estava no Portal do Representante e gostaria de falar com a Central de Atendimento ao Representante Eudora',
    },
    page401: {
      subtitle:
        'Para continuar o pedido, você precisa entrar no Portal novamente e acessar “Fazer pedido”. Não se preocupe, se você já tiver incluído itens no carrinho, você poderá vê-los novamente após o login.',
    },
  },
  isAdministrateTax: true,
  google: {
    gtm: {
      containerID: 'GTM-56L8KFR',
    },
    analytics: {
      id: 'XXXXXXXX',
    },
    recaptcha: {
      secretKey: recaptchaSecretKey,
    },
  },
  pickupStore: 18,
  reseller: 1,
  retroActiveReseller: 9,
  newRelic: {
    accountID: '3160087',
    agentID: '601425425',
    licenseKey: newRelicLicenseKey,
    trustKey: '3080127',
  },
  oneTrustCookie: {
    key: oneTrustCookieKey,
  },
  prismic: {
    accessToken: '',
    apiUrl: 'https://re-eudora.cdn.prismic.io/api/v2',
    repo: 're-eudora',
  },
  seo: {
    title: 'Representante Eudora',
    meta: {
      description:
        'Site exclusivo para Representante Eudora. Faça pedidos on-line de forma rápida e prática.',
      'theme-color': '#786A47',
    },
    links: [
      {
        rel: 'icon',
        type: 'image/png',
        href: `/static/eudora/favicon.png?v=${sharedConfig.app.version}`,
      },
      {
        rel: 'apple-touch-icon',
        href: `/static/eudora/favicon192x192.png?v=${sharedConfig.app.version}`,
      },
      {
        rel: 'apple-touch-icon',
        href: `/static/eudora/favicon512x512.png?v=${sharedConfig.app.version}`,
      },
      { rel: 'manifest', href: `/static/eudora/manifest.json?v=${sharedConfig.app.version}` },
    ],
  },
  header: {
    fixed: true,
  },
  footer: {
    links: [
      {
        text: 'Termo de Uso',
        to: 'https://minhaloja-resources.grupoboticario.digital/terms/deb1fe65-586f-49fd-aea1-50ed0eac1616/deb1fe65-586f-49fd-aea1-50ed0eac1616.pdf',
      },
      {
        text: 'Política de Privacidade',
        to: 'https://www.grupoboticario.com.br/privacidade/',
      },
      {
        text: 'Proteja-se Contra Fraudes',
        to: 'https://grupoboticario.com.br/privacidade/privacidade-proteja-se/',
      },
    ],
    socialMediaAndApps: {
      accessibility: {
        facebookAlt: 'Acessar Facebook da Eudora',
        instagramAlt: 'Acessar Instagram da Eudora',
        youtubeAlt: 'Acessar Youtube da Eudora',
      },
      appCTA: 'Baixe o Aplicativo Representante Eudora',
      facebook: 'https://www.facebook.com/eudora',
      instagram: 'https://www.instagram.com/eudora/',
      youtube: 'https://www.youtube.com/user/eudora',
      android:
        'https://play.google.com/store/apps/details?id=br.com.eudora.apprepresentante&hl=pt_BR&gl=US',
      ios: 'https://apps.apple.com/br/app/representante-eudora/id1570275139',
    },
  },
  renegotiationSac: {
    whatsapp: '',
    phone: '0800 744 2700',
    portalName: 'Regulariza Grupo Boticário',
    portalLink: 'https://regularizagrupoboticario.com.br/?utm_source=portal_eud&utm_medium=pedidos',
    hours: {
      whatsapp: '',
      phone: 'Segunda a sexta, das 08h às 20h40. Sábado, das 08h às 14h20.',
      portal: 'Atendimento 24 horas',
    },
  },
  signup: {
    site: 'https://cadastro.eudora.com.br/?utm_source=portal-representante&utm_medium=botao&utm_content=quero-ser-representante',
  },
  ...shared,
};

if (process.env.NODE_ENV === 'test') {
  configBase.configCat.sdkKey = 'hQXZCNkV8kOCePsrAgp6EQ/Wi2iC23cd0eX-Z-J4O3k1g'; //Fake Key
}
if (process.env.REACT_APP_ENV === 'staging') {
  configBase.app.staticUrl = 'https://hreseller-checkout-eudora-mf-vd.grupoboticario.com.br';
  configBase.app.url = 'https://hreseller-checkout-eudora-mf-vd.grupoboticario.com.br/';
}

if (process.env.REACT_APP_ENV === 'production') {
  configBase.app.staticUrl = 'https://reseller-checkout-eudora-mf-vd.grupoboticario.com.br';
  configBase.app.url = 'https://reseller-checkout-eudora-mf-vd.grupoboticario.com.br/';
  configBase.app.fallbackUrl = 'https://representante.eudora.com.br';
  configBase.app.logout = 'https://representante.eudora.com.br/login';
  configBase.bff.baseUrl = 'https://api.grupoboticario.com.br/local/v1/unified-bff/';
  configBase.bff.clientID = 'Sc4GOQheqXui4QXA7J4xkoWptjZVaatn';
  configBase.newRelic.accountID = '3160087';
  configBase.newRelic.agentID = '601307333';

  configBase.pickupStore = 18;
}

const menuItens = {
  navBar: {
    links: [
      {
        iconeName: 'Home',
        text: 'Início',
        to: '/departamentos',
        hideToBlockedReseller: true,
        isLink: true,
        isOnlyMobile: false,
      },
      {
        iconeName: 'Book',
        text: 'Materiais',
        to: '/guia-digital',
        isLink: false,
        isOnlyMobile: false,
        submenu: [
          {
            title: 'Para compartilhar com clientes',
            links: [
              {
                description: 'Envie o catálogo',
                text: 'Guia Digital',
                to: '/guia-digital',
                isLink: true,
              },
              {
                description: 'Crie, baixe e compartilhe imagens do ciclo',
                text: 'Imagens de divulgação',
                to: '/imagens-de-divulgacao',
                isLink: true,
              },
            ],
          },
          {
            title: 'Para você representante',
            links: [
              {
                description: 'Atualizações do ciclo',
                text: 'Destaques do ciclo',
                to: '/destaques-do-ciclo',
                isLink: true,
              },
              {
                description: 'Aprenda a aumentar sua revenda',
                text: 'Dicas e treinamentos',
                to: '/dicas-e-treinamentos',
                isLink: true,
              },
              {
                description: 'Conheça novidades do ciclo',
                text: 'Guia Mais',
                to: '/guia-mais',
                isLink: true,
              },
              {
                description: 'Você pode escolher se quer receber o catálogo físico',
                text: 'Configurar catálogo',
                to: '/configurar-catalogo',
                isLink: true,
              },
            ],
          },
        ],
      },
      {
        iconeName: 'Box',
        text: 'Pedidos',
        to: '/pedidos',
        isLink: false,
        isOnlyMobile: false,
        submenu: [
          {
            title: 'Pedidos realizados',
            links: [
              {
                description: 'Consulte seus pedidos',
                text: 'Histórico de pedidos',
                to: '/pedidos?tab=historico',
                isLink: true,
              },
              {
                description: 'Consulte boletos em aberto',
                text: 'Segunda via de boleto',
                to: `/pedidos?tab=a-pagar`,
                isLink: true,
              },
              {
                description: 'Negocie os boletos',
                text: 'Regulariza Grupo Boticário',
                to: 'https://regularizagrupoboticario.com.br/?utm_source=portal_eud&utm_medium=pedidos',
                isLink: true,
              },
            ],
          },
        ],
      },
      {
        iconeName: 'StarOutline',
        text: 'Incentivos',
        to: '',
        isLink: false,
        isOnlyMobile: false,
        submenu: [
          {
            title: 'Campanhas de incentivo',
            component: 'Loyalty',
          },
        ],
      },
      {
        iconeName: 'MegaPhone',
        text: 'Promoções',
        to: '',
        isLink: false,
        isOnlyMobile: false,
        submenu: [
          {
            title: 'Condições especiais',
            links: [
              {
                description: 'Consulte as últimas unidades',
                text: 'Bazar',
                to: `${configBase.app.url}vitrines?tag=${configBase.app.short}-{CYCLE_NUMBER}-bazar-de-oportunidades`,
                isLink: true,
              },
              {
                description: 'Consulte as promoções',
                text: 'Promoções',
                to: `${configBase.app.url}vitrines?tag=${configBase.app.short}-{CYCLE_NUMBER}-promocoes`,
                isLink: true,
              },
            ],
          },
        ],
      },
      {
        iconeName: 'StoreFront',
        text: 'Gestão',
        to: '/gestao-de-vendas/minhas-vendas',
        isLink: true,
        isOnlyMobile: false,
        showBadgeNotification: true,
      },
      {
        iconeName: 'TreeLinesHorizontal',
        text: 'Mais',
        to: '',
        isLink: false,
        noShowMobile: true,
        isOnlyMobile: false,
        submenu: [
          {
            navColumns: [
              {
                title: 'Espaço da Representante',
                links: [
                  {
                    description: 'Loja com pronta entrega',
                    text: 'Encontre seu Espaço',
                    to: '/espaco-do-representante',
                    isLink: true,
                  },
                ],
              },
              {
                title: 'Treinamentos',
                links: [
                  {
                    description: 'Conheça melhor os produtos',
                    text: 'Universidade Eudora',
                    to: 'https://www.universidadeeudora.com.br/',
                    isLink: true,
                  },
                ],
              },
              {
                title: 'Sua conta',
                links: [
                  {
                    description: 'Confira seus dados e contatos de ajuda',
                    text: 'Perfil e Ajuda',
                    to: `/perfil`,
                    isLink: true,
                  },
                ],
              },
              {
                title: 'Informações',
                links: [
                  {
                    description: 'Leia os comunidados',
                    text: 'Avisos importantes',
                    to: '/avisos-importantes',
                    isLink: true,
                  },
                ],
              },
            ],
          },
          {
            title: 'Contato',
            component: 'EudoraInfo',
          },
          {
            title: 'Sair da conta',
            component: 'Logout',
          },
        ],
      },
      {
        iconeName: 'Person',
        text: 'Perfil e Ajuda',
        to: '/perfil',
        isLink: true,
        isOnlyMobile: true,
      },
      {
        iconeName: 'QuestionMarkCircle',
        text: 'Dúvidas',
        to: 'https://atendimento.force.com/eudorarepresentante/s/',
        isLink: true,
        isOnlyMobile: true,
      },
    ] as MenuItens['links'],
  },
};
const config: Config = { ...configBase, ...menuItens };

export default config;
